import axios from "axios";
const URL = "https://16d6zw.sse.codesandbox.io";
const API = axios.create({
  baseURL: URL
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("tkn")) {
    req.headers.authorization = `Bearer ${
      JSON.parse(localStorage.getItem("tkn")).tkn
    }`;
  }

  return req;
});

export const updateUser = (formData) => API.patch("/user/update", formData);
export const searchUsers = (formData) =>
  axios.post(`${URL}/user/findmatch`, formData);
